import oauthConfig from "./google-oauth.json";

export const GOOGLE_DRIVE_CONFIG = {
  // API_KEY: "AIzaSyD21KFaPIYRe-CGwj5KaqbrzqUCv7ETTbs",
  API_KEY: "AIzaSyBb_Mpzf2pf48meO4MNFIhU7lTMq30siro",
  CLIENT_ID: oauthConfig.web.client_id,
  CLIENT_SECRET: oauthConfig.web.client_secret,
  REDIRECT_URI: oauthConfig.web.redirect_uris[0],
  SCOPES: "https://www.googleapis.com/auth/drive.readonly",
  AUTH_URI: oauthConfig.web.auth_uri,
  TOKEN_URI: oauthConfig.web.token_uri,
};

export default GOOGLE_DRIVE_CONFIG;
